<template>
	<div>
		<b-modal id="modal-input" scrollable :no-close-on-backdrop=true :title="'Advance Filter'" :no-close-on-esc=true v-model="isFilterShow"
				 :dialog-class="''"
				 :ok-title="'Search'"
				 ok-variant="success"
				 :cancel-title="'Clear'"
				 @ok="getDeliveryInstructionDeliveryCards"
				 @hidden="resetModal">
			<b-card>
				<b-row>
					<b-col cols="12" lg="6">
					<app-input-combobox-autocomplete :options="deliveryInstructions" optionsLabel="diNumber" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Delivery Number" id="filter-" size="sm" :model.sync="filter.deliveryInstructionId" @input="getDeliveryInstructions" @focus="getDeliveryInstructions" />	
					<app-input-textbox id="fieldset-delivery-card-number" label-cols-sm="4" label-cols-lg="3" label="Delivery Card Number" label-for="filter-delivery-card-number" size="sm" :model.sync="filter.deliveryCardNumber" />
					<app-input-combobox-autocomplete :options="parts" optionsLabel="partNumber" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Part" id="filter-" size="sm" :model.sync="filter.partId" @input="getParts" @focus="getParts" />
					<app-input-textbox id="fieldset-dc-qty" label-cols-sm="4" label-cols-lg="3" label="DC Qty" label-for="filter-dc-qty" size="sm" :model.sync="filter.dcQty" />
					<app-input-datetimepicker-range id="fieldset-delivery-date" label-cols-sm="4" label-cols-lg="3" label="Delivery Date" size="sm" :modelFrom.sync="filter.deliveryDateFrom" :modelTo.sync="filter.deliveryDateTo" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" reset-button />
					</b-col>
					<b-col cols="12" lg="6">
					<b-form-group id="fieldset-is-fullfiled" label-cols-sm="4" label-cols-lg="3" label="Is Fullfiled" label-for="filter-is-fullfiled">
						<b-form-checkbox id="filter-is-fullfiled" class="float-right" v-model="filter.isFullfiled"></b-form-checkbox>
					</b-form-group>
					<app-input-combobox-autocomplete :options="controlCardStatuss" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Control Card Status" id="filter-" size="sm" :model.sync="filter.controlCardStatusId" @input="getControlCardStatuss" @focus="getControlCardStatuss" />
					<b-form-group id="fieldset-is-loading" label-cols-sm="4" label-cols-lg="3" label="Is Loading" label-for="filter-is-loading">
						<b-form-checkbox id="filter-is-loading" class="float-right" v-model="filter.isLoading"></b-form-checkbox>
					</b-form-group>
					<app-input-textbox id="fieldset-delivery-qty" label-cols-sm="4" label-cols-lg="3" label="Delivery Qty" label-for="filter-delivery-qty" size="sm" :model.sync="filter.deliveryQty" />
					</b-col>
					<b-col cols="12" lg="6">

						<b-button variant="danger" v-if="false" size="sm" class="float-right" @click="resetFilter"><span style="font-size: 0.75rem" class="mr-1"><b-icon-x></b-icon-x></span> Clear Filter</b-button>
						<b-button variant="primary" v-if="false" size="sm" class="float-right mr-1" @click="getDeliveryInstructionDeliveryCards"><span style="font-size: 0.75rem" class="mr-1"><b-icon-search></b-icon-search></span> Cari</b-button>
					</b-col>
				</b-row>
			</b-card>
			<template #modal-footer="{ ok }">
				<b-button size="sm" class="btn-default-white float-right" @click="resetFilter()">
					Clear
				</b-button>
				<b-overlay :show="isDataLoading"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="float-right ">
					<b-button size="sm" class="float-right btn-default" @click="ok()">
						Search
					</b-button>
				</b-overlay>
			</template>
		</b-modal>

		<div>
			<b-row class="mb-2 d-sm-none d-md-flex">
				<b-col class="pt-1">
					<span class="function-title">Delivery Instruction Delivery Card</span>
				</b-col>
				<b-col>
					<span class="float-right">
						<b-dropdown v-if="false" text="Action" class="m-md-2 btn-action-more" size="sm">
							<b-dropdown-item v-if="(userRole != null ? userRole.allowDownload : false)" href="files/deliveryinstructiondeliverycard/DeliveryInstructionDeliveryCard.xlsx"><b-icon-wallet class="mr-1"></b-icon-wallet> Download Template</b-dropdown-item>
							<b-dropdown-item v-if="(userRole != null ? userRole.allowUpdate : false)" @click="showPopupUploadData"><b-icon-upload class="mr-1"></b-icon-upload> Upload Data</b-dropdown-item>
							<b-dropdown-item v-if="(userRole != null ? userRole.allowPrint : false)" @click="printData"><b-icon-printer class="mr-1"></b-icon-printer> Export To Pdf</b-dropdown-item>
						</b-dropdown>
                        <b-overlay v-if="false"
                                   :show="isCreateBusy"
                                   opacity="0.6"
                                   spinner-small
                                   spinner-variant="default"
                                   class="d-inline">
                            <b-button class="btn-create btn-fill-success" to="/deliveryinstructiondeliverycard/create" size="sm"> <b-icon-plus-square class="mr-1"></b-icon-plus-square>Create New</b-button>
                        </b-overlay>

					</span>
					<Portal to="app-navbar-bottom">
						<span class="float-right">
                        <b-overlay v-if="(userRole != null ? userRole.allowCreate : false)"
                                   :show="isCreateBusy"
                                   opacity="0.6"
                                   spinner-small
                                   spinner-variant="default"
                                   class="d-inline">
                            <b-button class="btn-create btn-fill-success" to="/deliveryinstructiondeliverycard/create" size="sm"> <b-icon-plus-square class="mr-1"></b-icon-plus-square>Create New</b-button>
                        </b-overlay>

						</span>
					</Portal>
				</b-col>
			</b-row>
			<div class="table-corner">
				<div class="table-action-button">
					<b-button v-if="true" class="btn-action d-sm-none d-md-inline" size="sm" @click="downloadData"><b-icon-download class="mr-1"></b-icon-download> Download</b-button>
					
					<b-overlay v-if="false"
							   :show="isDeleteBusy"
							   rounded
							   opacity="0.6"
							   spinner-small
							   spinner-variant="primary"
							   class="d-inline-block">
						<click-confirm>
							<b-button class="btn-action" @click="deleteMultipleData" size="sm"><b-icon-trash class="mr-1"></b-icon-trash> Delete</b-button>
						</click-confirm>
					</b-overlay>
					
					<b-button v-if="isShowAdvanceFilterButton" class="btn-action" size="sm" @click="isFilterShow = true"><b-icon-search class="mr-1"></b-icon-search> {{ 'Advance Filter' | countFilter(filter) }} </b-button>
					<span class="d-inline d-md-none">
						<b-button v-if="!isStacked" class="btn-action float-right btn-action-scroll" size="sm" @click="isStacked = true"><b-icon-view-stacked></b-icon-view-stacked></b-button>
						<b-button v-else class="btn-action float-right btn-action-scroll" size="sm" @click="isStacked = false"><b-icon-table></b-icon-table></b-button>
					</span>
					<span>
						<b-button :disabled="isPullRight" class="btn-action float-right btn-action-scroll" size="sm" @click="scrollRight"><b-icon-caret-right-fill></b-icon-caret-right-fill></b-button>
						<b-button :disabled="isPullLeft" class="btn-action float-right btn-action-scroll" size="sm" @click="scrollLeft"><b-icon-caret-left-fill></b-icon-caret-left-fill></b-button>
					</span>
				</div>
				<b-table sticky-header="565px" :stacked="isStacked" id="table-list-deliveryinstructiondeliverycard" :class="'table-action ' + (isStacked ? '' : 'table-index')" head-variant="head-light" :bordered="true" :no-local-sorting="true" :items="deliveryInstructionDeliveryCards" :fields="fields" :busy="isDataLoading" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" small responsive show-empty :tbody-tr-class="rowClass">
					<template #empty>
						<app-no-data-image />
					</template>
					<template #table-busy v-if="deliveryInstructionDeliveryCards.length <= 0">
						<app-no-data-image :animate="true" />
					</template>
					<template v-slot:head(front-action)>
						<b-button @click="isShowFilter = !isShowFilter" size="sm" class="btn-filter float-right"><b-icon-funnel /></b-button>
					</template>
					<template #top-row v-if="isShowFilter">
						<b-th></b-th>
						<b-th></b-th>
				<b-th stacked-heading="Delivery Number" class="table-filter">
					<v-select append-to-body label="diNumber" :options="deliveryInstructions" :value="filter.deliveryInstructionId" :reduce="item => item.id" v-model="filter.deliveryInstructionId" :filterable="true" @input="getDeliveryInstructionDeliveryCardsWithoutLoading" @search="getDeliveryInstructions"></v-select>
				</b-th>
				<b-th stacked-heading="Delivery Card Number" class="table-filter">
					<b-form-input id="input-delivery-card-number-table" @input="getDeliveryInstructionDeliveryCardsWithoutLoading" v-model="filter.deliveryCardNumber" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Part" class="table-filter">
					<v-select append-to-body label="partNumber" :options="parts" :value="filter.partId" :reduce="item => item.id" v-model="filter.partId" :filterable="true" @input="getDeliveryInstructionDeliveryCardsWithoutLoading" @search="getParts"></v-select>
				</b-th>
				<b-th stacked-heading="DC Qty" class="table-filter">
					<b-form-input id="input-dc-qty-table" @input="getDeliveryInstructionDeliveryCardsWithoutLoading" v-model="filter.dcQty" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="DI Detail" class="table-filter" v-if="false">
					<v-select append-to-body label="part" :options="deliveryInstructionDetails" :value="filter.deliveryInstructionDetailId" :reduce="item => item.id" v-model="filter.deliveryInstructionDetailId" :filterable="true" @input="getDeliveryInstructionDeliveryCardsWithoutLoading" @search="getDeliveryInstructionDetails"></v-select>
				</b-th>
				<b-th stacked-heading="Delivery Date" class="table-filter">
					<app-input-datetimepicker-range id="fieldset-delivery-date" label-cols-sm="4" label-cols-lg="3" :nolabel="true" label="Delivery Date" size="sm" :modelFrom.sync="filter.deliveryDateFrom" :modelTo.sync="filter.deliveryDateTo" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" reset-button  @change="getDeliveryInstructionDeliveryCardsWithoutLoading" />
				</b-th>
				<b-th stacked-heading="Sequence" class="table-filter">
					<b-form-input id="input-sequence-table" @input="getDeliveryInstructionDeliveryCardsWithoutLoading" v-model="filter.sequence" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Total Delivery Card" class="table-filter">
					<b-form-input id="input-total-delivery-card-table" @input="getDeliveryInstructionDeliveryCardsWithoutLoading" v-model="filter.totalDeliveryCard" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Is Fullfiled" class="table-filter">
					<v-select append-to-body label="name" :options="yesNoCombo" :value="filter.isFullfiledId" :reduce="item => item.id" v-model="filter.isFullfiled" :filterable="true" @input="getDeliveryInstructionDeliveryCardsWithoutLoading" ></v-select>
				</b-th>
				<b-th stacked-heading="Control Card Status" class="table-filter">
					<v-select append-to-body label="name" :options="controlCardStatuss" :value="filter.controlCardStatusId" :reduce="item => item.id" v-model="filter.controlCardStatusId" :filterable="true" @input="getDeliveryInstructionDeliveryCardsWithoutLoading" @search="getControlCardStatuss"></v-select>
				</b-th>
				<b-th stacked-heading="Is Loading" class="table-filter">
					<v-select append-to-body label="name" :options="yesNoCombo" :value="filter.isLoadingId" :reduce="item => item.id" v-model="filter.isLoading" :filterable="true" @input="getDeliveryInstructionDeliveryCardsWithoutLoading" ></v-select>
				</b-th>
				<b-th stacked-heading="Delivery Qty" class="table-filter">
					<b-form-input id="input-delivery-qty-table" @input="getDeliveryInstructionDeliveryCardsWithoutLoading" v-model="filter.deliveryQty" size="sm"></b-form-input>
				</b-th>

					</template>
					<template v-slot:cell(no)="row">
						{{ ((row.index + 1) + ( pageSizeOptions * (currentPage - 1))) }}
					</template>

					<template v-slot:cell(deliveryNumber)="row">
						{{ row.item.deliveryInstructionDetail.deliveryInstructionDiNumber }}
					</template>

					<template v-slot:cell(deliverycardnumber)="row">

                <a @click="() => ( $router.push({ name: 'deliveryinstructiondeliverycarddetail', params : { id: row.item.id } }))" class="a-link-detail">
							{{ row.item.deliveryCardNumber != null && row.item.deliveryCardNumber != "" ?
								(typeof row.item.productCode == 'string') ?
									row.item.deliveryCardNumber.slice(0, 30) + (row.item.deliveryCardNumber.length > 30 ? "..." : "" ) : row.item.deliveryCardNumber : "" }}
						</a>
            
					</template>

			<template v-slot:cell(part)="row">
				{{ row.item.part != null ? row.item.part.partNumber : "" }}
			</template>
			<template v-slot:cell(deliveryInstructionDetail)="row" v-if="false">
				{{ row.item.deliveryInstructionDetail != null ? row.item.deliveryInstructionDetail.part : "" }}
			</template>
			<template v-slot:cell(deliveryDate)="row">
				{{ row.item.deliveryDate | moment("DD-MMM-YYYY HH:mm") }}
			</template>
			<template v-slot:cell(controlCardStatus)="row">
				{{ row.item.controlCardStatus != null ? row.item.controlCardStatus.name : "" }}
			</template>

					<template v-slot:cell(front-action)="row">
						<div class="d-flex justify-content-center ml-2" v-if="false">
							<b-form-checkbox :id="'input-is-checked-' + (row.index + 1)" @change="toggleSelect(Number(row.item.id))" :checked="checkAllData.includes(Number(row.item.id))"></b-form-checkbox>
						</div>
					</template>
					<template v-slot:cell(actions)="row">
						<span>
							<b-button size="sm" @click="row.toggleDetails" class="mr-2 btn-sm btn-transparent border-0">
								<b-icon-chevron-down v-if="!row.detailsShowing"></b-icon-chevron-down>
								<b-icon-chevron-up v-else></b-icon-chevron-up>
							</b-button>
						</span>
					</template>
					<template #row-details="row">
						<b-card>
						<app-input-textbox id="fieldset-dc-qty" label-cols-lg="12"  label="DC Qty" label-for="input-dc-qty" size="sm" :model.sync="row.item.dcQty"   :isEditable="false" :isUpdatable="true" />
						<app-input-combobox v-if="false" optionsLabel="part" label-cols-sm="12" :model="row.item.deliveryInstructionDetailId" label="DI Detail" :selected="row.item.deliveryInstructionDetail != null ? row.item.deliveryInstructionDetail.part : ''" :isEditable="false" :isUpdatable="true" />
						<app-input-datetimepicker id="fieldset-delivery-date" label-cols-lg="12"  label="Delivery Date" size="sm" :model.sync="row.item.deliveryDate"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"  :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-sequence" label-cols-lg="12"  label="Sequence" label-for="input-sequence" size="sm" :model.sync="row.item.sequence"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-total-delivery-card" label-cols-lg="12"  label="Total Delivery Card" label-for="input-total-delivery-card" size="sm" :model.sync="row.item.totalDeliveryCard"   :isEditable="false" :isUpdatable="true" />
						<app-input-checkbox id="fieldset-is-is-fullfiled" label-cols-lg="12" label="Is Fullfiled" label-for="input-is-is-fullfiled" size="sm" :model.sync="row.item.isFullfiled" :isEditable="false" :isUpdatable="true" checkedValue="Yes" uncheckedValue="No"  />
						<app-input-combobox optionsLabel="name" label-cols-sm="12" :model="row.item.controlCardStatusId" label="Control Card Status" :selected="row.item.controlCardStatus != null ? row.item.controlCardStatus.name : ''" :isEditable="false" :isUpdatable="true" />
						<app-input-checkbox id="fieldset-is-is-loading" label-cols-lg="12" label="Is Loading" label-for="input-is-is-loading" size="sm" :model.sync="row.item.isLoading" :isEditable="false" :isUpdatable="true" checkedValue="Yes" uncheckedValue="No"  />
						<app-input-textbox id="fieldset-delivery-qty" label-cols-lg="12"  label="Delivery Qty" label-for="input-delivery-qty" size="sm" :model.sync="row.item.deliveryQty"   :isEditable="false" :isUpdatable="true" />

						</b-card>
					</template>
				</b-table>
			</div>
			<b-row>
				<b-col cols="12" class="paging-container">
					<div>
						<b-row>
							<b-col cols="12">
								<b-pagination class="btn-paging paging-page-size"
									v-model="currentPage"
									:total-rows="(deliveryInstructionDeliveryCardsPaging != null ? deliveryInstructionDeliveryCardsPaging.dataCount : 0)"
									:per-page="(deliveryInstructionDeliveryCardsPaging != null ? deliveryInstructionDeliveryCardsPaging.pageSize : 0)"
									aria-controls="my-table">
									<template #first-text>
										<b-icon-chevron-left />
									</template>
									<template #prev-text>
										Prev
									</template>
									<template #next-text>
										Next
									</template>
									<template #last-text>
										<b-icon-chevron-right />
									</template>
								</b-pagination>
								<span class="paging-page-size">
									<b-form-select v-if="false" v-model="pageSizeOptions" size="sm" class="float-right" :options="pagingOptions"></b-form-select>
									<b-dropdown :text="pageSizeOptions + ' per page'" class="m-md-2 btn-paging-size" size="sm">
										<b-dropdown-item v-for="item in pagingOptions" :key="item.value" @click="pageSizeOptions = item.value">
											{{ item.text }}
										</b-dropdown-item>
									</b-dropdown>
								</span>
							</b-col>
						</b-row>
					</div>
				</b-col>
			</b-row>
		</div>
        <Upload :openPopup="showPopupUpload"
            @resetMethod="resetModalUpload"
            @uploadButtonMethod="uploadData" />
        <PopupDownload :openPopup="showPopupDownload"
            :processId="processId"
            @resetModalMethod="resetModal"
            label="Popup Download"
            :contentLabel="popupDownloadLabel" />
        <PopupPDF :openPopup="isShowPopupPDF"
            :pdfUrl="pdfUrl"
            @resetModalMethod="resetModal"
            label="Popup PDF" />
		<RouterView />
	</div>
</template>
<style lang="scss" scoped>
	@import '../../assets/scss/index-page.scss';

    

    ::v-deep #table-list-deliveryinstructiondeliverycard.b-table.b-table-stacked > tbody > tr > td.th-front-action::before {
        background-image: url(/img/box-checklist.png);
        background-size: 40px 40px;
        display: block;
        width: 40px;
        height: 40px;
        content: "";
        margin-bottom: 10px;
    }

	::v-deep #table-list-deliveryinstructiondeliverycard.b-table>thead>tr>th {
		background: #e28b29;
	}

    ::v-deep #table-list-deliveryinstructiondeliverycard.b-table.b-table-stacked > tbody > tr > td.th-front-action > div {
        display: flex;
    }
</style>
<script>
import DeliveryInstructionDeliveryCard from '@/models/DeliveryInstructionDeliveryCard/DeliveryInstructionDeliveryCard';
import DeliveryInstructionDeliveryCardList from '@/models/DeliveryInstructionDeliveryCard/DeliveryInstructionDeliveryCardList';
import DeliveryInstructionDeliveryCardFilter from '@/filters/DeliveryInstructionDeliveryCard/DeliveryInstructionDeliveryCardFilter';
import RoleDetail from '@/models/Core/RoleDetail';

import AppLabel from '@/components/AppLabel';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import AppInputCombobox from '@/components/AppInputCombobox';
import AppInputTextarea from '@/components/AppInputTextarea';
import PartFilter from '@/filters/Part/PartFilter';
import Part from '@/models/Part/Part';
import AppInputTextbox from '@/components/AppInputTextbox';
import DeliveryInstructionDetailFilter from '@/filters/DeliveryInstruction/DeliveryInstructionDetailFilter';
import DeliveryInstructionDetail from '@/models/DeliveryInstruction/DeliveryInstructionDetail';
import DeliveryInstructionFilter from '@/filters/DeliveryInstruction/DeliveryInstructionFilter';
import DeliveryInstruction from '@/models/DeliveryInstruction/DeliveryInstruction';
import AppInputDatetimepicker from '@/components/AppInputDatetimepicker';
import AppInputDatetimepickerRange from '@/components/AppInputDatetimepickerRange';
import AppInputCheckbox from '@/components/AppInputCheckbox';
import ControlCardStatusFilter from '@/filters/ControlCardStatus/ControlCardStatusFilter';
import ControlCardStatus from '@/models/ControlCardStatus/ControlCardStatus';
import PopupDownload from '@/components/PopupDownload';
import PopupPDF from '@/components/PopupPDF';
import PopupDataEditNotification from '@/components/PopupDataEditNotification';
import Upload from './Upload';

export default {
	components : {
		DeliveryInstructionDeliveryCard, 
		DeliveryInstructionDeliveryCardList, 
		DeliveryInstructionDeliveryCardFilter, 
		AppLabel,
		AppInputTextarea,
		AppInputComboboxAutocomplete,
		AppInputCombobox,
		AppInputTextbox,
		AppInputDatetimepicker,
		AppInputDatetimepickerRange,
		AppInputCheckbox,
		PopupDownload,
		PopupPDF,
		Upload,
		PopupDataEditNotification,
	},
	data() {
		return {
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			perPage: 10,
			currentPage: 1,
			totalData:0,
			fields: [
				{"front-action": { "class" : "th-front-action", "label" : ""}},
				{"no" : {"class" : "th-number d-stack-none"}},
				{"deliveryNumber": {}, "class" : "th-delivery-number", "label" : "Delivery Number", key: 'deliveryNumber', sortable: true},
				{"deliveryCardNumber": {}, "class" : "th-delivery-card-number first-child", "label" : "Delivery Card Number", key: 'deliveryCardNumber', sortable: true}, 
				{"part": {}, "class" : "th-part", "label" : "Part", key: 'part', sortable: true}, 
				{"dcQty": {}, "class" : "th-dc-qty last-child", "label" : "DC Qty", key: 'dcQty', sortable: true}, 
				// {"deliveryInstructionDetail": {}, "class" : "th-delivery-instruction-detail d-stack-none", "label" : "DI Detail", key: 'deliveryInstructionDetail', sortable: true}, 
				{"deliveryDate": {}, "class" : "th-delivery-date d-stack-none", "label" : "Delivery Date", key: 'deliveryDate', sortable: true}, 
				{"sequence": {}, "class" : "th-sequence d-stack-none", "label" : "Sequence", key: 'sequence', sortable: true}, 
				{"totalDeliveryCard": {}, "class" : "th-total-delivery-card d-stack-none", "label" : "Total Delivery Card", key: 'totalDeliveryCard', sortable: true}, 
				{"isFullfiled": {}, "class" : "th-is-fullfiled d-stack-none", "label" : "Is Fullfiled", key: 'isFullfiled', sortable: true}, 
				{"controlCardStatus": {}, "class" : "th-control-card-status d-stack-none", "label" : "Control Card Status", key: 'controlCardStatus', sortable: true}, 
				{"isLoading": {}, "class" : "th-is-loading d-stack-none", "label" : "Is Loading", key: 'isLoading', sortable: true}, 
				{"deliveryQty": {}, "class" : "th-delivery-qty d-stack-none", "label" : "Delivery Qty", key: 'deliveryQty', sortable: true}, 

				{"actions": {"class" : "th-actions d-stack-show", "label" : ""}}
			],
			yesNoCombo: [
				{ id : 'TRUE', name : 'True', selected:true },
				{ id : 'FALSE', name : 'False' },
			],
			busy:false,
			isDataLoading: false,
			isDownloadDataBusy: false,
			isMultiplePrintBusy: false,
			showPopupUpload: false,
			showPopupDownload: false,
			isShowPopupPDF: false,
			pdfUrl: "",
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			filter: null,
			processId: "",
			popupDownloadLabel: "",
			hasLoadedData: false,
			showFilter: false,
			isShowFilter: false,
			isCreateBusy: false,
			btnEditData: [],
			currentDataId: null,
			selectedModel: null,
			deliveryInstructionDeliveryCards: [],
			deliveryInstructionDeliveryCardsPaging: {},
			parts : [],
			deliveryInstructionDetails : [],
			controlCardStatuss : [],

			isApprovalBusy: false,
			isFilterShow: false,
			isDeleteBusy: false,
			isPullRight: false,
			isPullLeft: true,
			isStacked: false,
			isScannerMode: false,
			deliveryInstructions: [],
			
		}
	},	methods : {
		getDeliveryInstructionDeliveryCards : async function() {
			this.isDataLoading = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			await DeliveryInstructionDeliveryCard.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(async result => {
				if (result != null) {
					this.deliveryInstructionDeliveryCards = result.data
					this.deliveryInstructionDeliveryCardsPaging = result
				}
				this.isDataLoading = false;
			})
			.catch(error => {
				this.isDataLoading = false;
			});
		},
		getDeliveryInstructionDeliveryCardsWithoutLoading : async function() {
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			await DeliveryInstructionDeliveryCard.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.deliveryInstructionDeliveryCards = result.data
					this.deliveryInstructionDeliveryCardsPaging = result
				}
			})
			.catch(error => {});
		},
		
		getParts : async function(input) {
			let filter = new PartFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}
			await Part.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.parts = result.data
				}
			})
			.catch(error => {});
		},
		getDeliveryInstructions : async function(input) {
			let filter = new DeliveryInstructionFilter();
			if (input != undefined) {
				filter.diNumber = input;
			}

			if(this.filter.deliveryInstructionId != undefined && input == '') {
				filter.id = this.filter.deliveryInstructionId;
			}

			await DeliveryInstruction.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.deliveryInstructions = result.data
				}
			})
			.catch(error => {});
		},
		getDeliveryInstructionDetails : async function(input) {
			let filter = new DeliveryInstructionDetailFilter();
			if (input != undefined) {
				filter.part = input;
			}
			await DeliveryInstructionDetail.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.deliveryInstructionDetails = result.data
				}
			})
			.catch(error => {});
		},
		getControlCardStatuss : async function(input) {
			let filter = new ControlCardStatusFilter();
			if (input != undefined) {
				filter.name = input;
			}
			await ControlCardStatus.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.controlCardStatuss = result.data
				}
			})
			.catch(error => {});
		},

		resetFilter() {
			this.filter = new DeliveryInstructionDeliveryCardFilter();
			this.getDeliveryInstructionDeliveryCards();
			this.isFilterShow = false;
		},
		showPopupUploadData() {
			this.showPopupUpload = true;
		},
		uploadData(modalEvent) {
			this.showPopupUpload = false;
		},
		resetModal() {
			this.showPopupUpload = false;
			this.showPopupDownload = false;
			this.isShowPopupPDF = false;
			this.isFilterShow = false;
		},
		resetModalUpload() {
			this.showPopupUpload = false;
			this.getDeliveryInstructionDeliveryCards();
		},
		toggleSelect(id) {
			if (this.checkAllData.includes(id)) {
				this.$store.dispatch("removeCheckData", id);
			} else {
				this.$store.dispatch("addCheckData", id);
			}
		},
		showPopupPrint(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di cetak";
			this.processId = id;
		},
		showPopupDownloadData(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di unduh";
			this.processId = id;
		},
		showPopupPDF(url) {
			this.isShowPopupPDF = true;
			this.pdfUrl = url;
		},
		printData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isMultiplePrintBusy = true;
				DeliveryInstructionDeliveryCard.multiPagePrint(this).then(result => {
					if (result) {
						this.showPopupPrint(result.id);
					}
				this.isMultiplePrintBusy = false;
				}).catch(error => { this.isMultiplePrintBusy = false; });
			}
		},
		printSingleData(id) {
			DeliveryInstructionDeliveryCard.singleDataPagePrint(this, id).then(result => {
				if (result) {
					this.showPopupPDF(result.download);
				}
			});
		},
		downloadData() {
			this.isDownloadDataBusy = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}
			
			console.log('this.filter', this.filter);
			DeliveryInstructionDeliveryCard.downloadData(this, this.filter, this.sortingBy)
			.then(result => {
				console.log('result ', result);
				if (result) {
					this.showPopupDownloadData(result.id);
				}
				this.isDownloadDataBusy = false;
			})
			.catch(error => { 
				this.isDownloadDataBusy = false; 
			})
		},

		deleteData(id) {
			DeliveryInstructionDeliveryCard.deleteData(this, id).then(result => {
				if (result)
				{
					this.getDeliveryInstructionDeliveryCards();
				}
			})
		},
		deleteMultipleData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isDeleteBusy = true;
				DeliveryInstructionDeliveryCard.deleteMultipleData(this).then(result => {
					this.getDeliveryInstructionDeliveryCards();
					this.isDeleteBusy = false;
				}).catch(error => { this.isDeleteBusy = false; });
			}
		},
		onResize() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 576) {
				this.isStacked = true;
			} else {
				this.isStacked = false;
			}
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768) {
				this.isShowFilter = true;
			} else {
				this.isShowFilter = this.showFilter;
			}
		},


		scrollRight() {
			var tableDeliveryInstructionDeliveryCardParent = document.getElementById('table-list-deliveryinstructiondeliverycard').parentNode;
			tableDeliveryInstructionDeliveryCardParent.scrollLeft += 250;
			this.isPullLeft = false;
			this.isPullRight = false;
			if ((tableDeliveryInstructionDeliveryCardParent.scrollWidth - tableDeliveryInstructionDeliveryCardParent.offsetWidth) == Math.ceil(tableDeliveryInstructionDeliveryCardParent.scrollLeft)) {
				this.isPullRight = true;
			}
		},
		scrollLeft() {
			var tableDeliveryInstructionDeliveryCardParent = document.getElementById('table-list-deliveryinstructiondeliverycard').parentNode;
			tableDeliveryInstructionDeliveryCardParent.scrollLeft -= 250;
			this.isPullRight = false;
			this.isPullLeft = false;
			if (tableDeliveryInstructionDeliveryCardParent.scrollLeft <= 0) {
				this.isPullLeft = true;
			}
		},
		rowClass(item, type) {
			if (!item || type !== 'row') return
			if (this.checkAllData.includes(Number(item.id))) return 'item-active';
		}
	},
	beforeMount() {
		this.$store.dispatch("removeCheckAllData");
		this.filter = new DeliveryInstructionDeliveryCardFilter();
		this.getParts()
		// this.getDeliveryInstructionDetails()
		this.getDeliveryInstructions();
		this.getControlCardStatuss()
	},
	mounted(){
		let breadcrumb =[
			"Master Data", 
			"Delivery Instruction Delivery Card"
		];
		this.$store.dispatch('setBreadCrumb', breadcrumb);
		this.onResize();
		this.$nextTick(() => {
			this.getDeliveryInstructionDeliveryCards();
			window.addEventListener('resize', this.onResize);
		});
	},	watch: {
		sortBy: {
			handler: function() {
				this.getDeliveryInstructionDeliveryCards();
			}
		},
		sortDesc: {
			handler: function() {
				this.getDeliveryInstructionDeliveryCards();
			}
		},
		currentPage: {
			handler: function() {
				this.getDeliveryInstructionDeliveryCards();
			}
		},
		pageSizeOptions: {
			handler: function() {
				this.getDeliveryInstructionDeliveryCards();
			}
		},
		selectAll(newValue) {
			if (newValue) {
				DeliveryInstructionDeliveryCard.checkAllData(this, this.filter, this.sortingBy);
			} else {
				this.$store.dispatch("removeCheckAllData");
			}
		},
		'$route'(to, from) {
			if (to != null) {
				if (to.name == "deliveryinstructiondeliverycardindex") {
					this.getDeliveryInstructionDeliveryCardsWithoutLoading();
				}
			}
		},
	},
	computed: {
		checkAllData() {
			return this.$store.state.dataIds;
		},
		userRole() {
			return RoleDetail.query().where("functionInfoId", "delivery_instruction_delivery_card").first();
		},
		isShowDeleteButton : function() {
			let userRoleAllowDelete = true;
			if (this.userRole != null) {
				userRoleAllowDelete = this.userRole.allowDelete;
			}
			
			if (window.innerWidth <= 576) {
				if (userRoleAllowDelete) {
					if (this.checkAllData.length > 0) return true;
				}
				return false;
			}

			return userRoleAllowDelete;
		},
		isShowAdvanceFilterButton : function() {
			if (window.innerWidth <= 576) {
				if (this.checkAllData.length <= 0) return true;
				return false;
			}
			return true;
		}
	},	beforeDestroy() {
		this.$store.dispatch("removeCheckAllData");
	},
}
</script>
